export default function () {
  return {
    errors: {},
    icon: '',
    modality: {
      id: null,
      name: '',
      icon: '',
      addressRequired: false,
    },
  }
}
